import { useRef, useEffect } from "react";
import { MessagePartInputExtended } from "@/pages/BulkMessaging/types";
import {
  createTextMessagePart,
  createImageMessagePart,
  createEmptyMessagePart,
} from "@/pages/BulkMessaging/utils/apiHelpers";

interface UseMessageElementsProps {
  messageParts: MessagePartInputExtended[];
  onChange: (messageParts: MessagePartInputExtended[]) => void;
}

export const useMessageElements = ({
  messageParts,
  onChange,
}: UseMessageElementsProps) => {
  const hasCreatedDefault = useRef(false);

  useEffect(() => {
    if (messageParts.length === 0 && !hasCreatedDefault.current) {
      hasCreatedDefault.current = true;
      onChange([createEmptyMessagePart()]);
    }
  }, [messageParts.length, onChange]);

  const handleEditMessagePart = (
    index: number,
    content?: string,
    images?: File[],
  ) => {
    const updatedMessageParts = [...messageParts];

    if (content !== undefined) {
      updatedMessageParts[index] = createTextMessagePart(content);
    }

    if (images !== undefined) {
      if (images.length > 0) {
        updatedMessageParts[index] = createImageMessagePart(images[0]);
      } else {
        updatedMessageParts.splice(index, 1);
      }
    }

    onChange(updatedMessageParts);
  };

  const handleDeleteMessagePart = (index: number) => {
    if (messageParts.length === 1) {
      const updatedMessageParts = [...messageParts];
      updatedMessageParts[0] = createEmptyMessagePart();
      onChange(updatedMessageParts);
    } else {
      onChange(messageParts.filter((_, i) => i !== index));
    }
  };

  const handleAddText = () => {
    onChange([...messageParts, createEmptyMessagePart()]);
  };

  const handleAddImage = () => {
    onChange([...messageParts, createTextMessagePart("__IMAGE_ELEMENT__")]);
  };

  return {
    handleEditMessagePart,
    handleDeleteMessagePart,
    handleAddText,
    handleAddImage,
  };
};
